var baseStyleContainer = function baseStyleContainer() {
  return {};
};
var baseStyleLabel = function baseStyleLabel() {
  return {
    color: 'gray.400'
  };
};
var baseStyleValue = function baseStyleValue() {
  return {};
};
var baseStyle = {
  container: baseStyleContainer(),
  label: baseStyleLabel(),
  value: baseStyleValue()
};
var Editable = {
  baseStyle: baseStyle
};
export { Editable as default };